import React, { Component } from 'react';
import axios from 'axios';


import {
  NavLink,
  Redirect
} from 'react-router-dom';


class SunumEligard extends Component {

  constructor(props) {
    super(props);
    this.state = {
      name: '',
      email: '',
      date: '',
      sunum01: [],
      sunum02: [],
      sunum03: [],
      sunum04: [],
      sunum05: [],
      sunum06: [],
      sunum07: []
    }
  }

  componentDidMount() {
  
  const sonuc19 = 19;
  const sonuc24 = 24;
  const sonuc11 = 11;

    var uid = localStorage.getItem('uid');
    var auth = localStorage.getItem('auth');
  	const postId = location.pathname.split("/")[2];
  	//console.log(postId);
  
        var url01 = 'https://api.recordatifocus.com/eligard-sonuc-01/' + postId;
        fetch(url01)
            .then(response01 => response01.json())
            .then(data01 => this.setState({
                sunum01: data01
            }));
        var url02 = 'https://api.recordatifocus.com/eligard-sonuc-02/' + postId;
        fetch(url02)
            .then(response02 => response02.json())
            .then(data02 => this.setState({
                sunum02: data02
            }));
        var url03 = 'https://api.recordatifocus.com/eligard-sonuc-03/' + postId;
        fetch(url03)
            .then(response03 => response03.json())
            .then(data03 => this.setState({
                sunum03: data03
            }));
        var url04 = 'https://api.recordatifocus.com/eligard-sonuc-04/' + postId;
        fetch(url04)
            .then(response04 => response04.json())
            .then(data04 => this.setState({
                sunum04: data04
            }));
        var url05 = 'https://api.recordatifocus.com/eligard-sonuc-05/' + postId;
        fetch(url05)
            .then(response05 => response05.json())
            .then(data05 => this.setState({
                sunum05: data05
            }));
        var url06 = 'https://api.recordatifocus.com/eligard-sonuc-06/' + postId;
        fetch(url06)
            .then(response06 => response06.json())
            .then(data06 => this.setState({
                sunum06: data06
            }));
        var url07 = 'https://api.recordatifocus.com/eligard-sonuc-07/' + postId;
        fetch(url07)
            .then(response07 => response07.json())
            .then(data07 => this.setState({
                sunum07: data07
            }));



        }


        render() {
	// soru 01
                const {
                    sunum01
                } = this.state;
                let outputData01 = sunum01.map((item) => {
                    return {
                        cevap01: parseInt(item.cevap),
                    };
                });
                const result01 = Object.values(outputData01).reduce(
                    (r, {
                        cevap01
                    }) => r + cevap01,
                    0
                );
                const longeur01 = sunum01.length;
                let sonuc01 = 100 - (result01 * 100) / longeur01;
                console.log("Soru10 yanlis orani:", sonuc01);
	  // soru 02
                  const {
                    sunum02
                } = this.state;
                let outputData02 = sunum02.map((item) => {
                    return {
                        cevap02: parseInt(item.cevap),
                    };
                });
                const result02 = Object.values(outputData02).reduce(
                    (r, {
                        cevap02
                    }) => r + cevap02,
                    0
                );
                const longeur02 = sunum02.length;
                let sonuc02 = 100 - (result02 * 100) / longeur02;
                console.log("Soru02 yanlis orani:", sonuc02);
	  // soru 03
                  const {
                    sunum03
                } = this.state;
                let outputData03 = sunum03.map((item) => {
                    return {
                        cevap03: parseInt(item.cevap),
                    };
                });
                const result03 = Object.values(outputData03).reduce(
                    (r, {
                        cevap03
                    }) => r + cevap03,
                    0
                );
                const longeur03 = sunum03.length;
                let sonuc03 = 100 - (result03 * 100) / longeur03;
                console.log("Soru03 yanlis orani:", sonuc03);

	  // soru 04
                  const {
                    sunum04
                } = this.state;
                let outputData04 = sunum04.map((item) => {
                    return {
                        cevap04: parseInt(item.cevap),
                    };
                });
                const result04 = Object.values(outputData04).reduce(
                    (r, {
                        cevap04
                    }) => r + cevap04,
                    0
                );
                const longeur04 = sunum04.length;
                let sonuc04 = 100 - (result04 * 100) / longeur04;
                console.log("Soru04 yanlis orani:", sonuc04);

	  // soru 05
                  const {
                    sunum05
                } = this.state;
                let outputData05 = sunum05.map((item) => {
                    return {
                        cevap05: parseInt(item.cevap),
                    };
                });
                const result05 = Object.values(outputData05).reduce(
                    (r, {
                        cevap05
                    }) => r + cevap05,
                    0
                );
                const longeur05 = sunum05.length;
                let sonuc05 = 100 - (result05 * 100) / longeur05;
                console.log("Soru05 yanlis orani:", sonuc05);

	  // soru 06
                  const {
                    sunum06
                } = this.state;
                let outputData06 = sunum06.map((item) => {
                    return {
                        cevap06: parseInt(item.cevap),
                    };
                });
                const result06 = Object.values(outputData06).reduce(
                    (r, {
                        cevap06
                    }) => r + cevap06,
                    0
                );
                const longeur06 = sunum06.length;
                let sonuc06 = 100 - (result06 * 100) / longeur06;
                console.log("Soru06 yanlis orani:", sonuc06);

	  // soru 07
                  const {
                    sunum07
                } = this.state;
                let outputData07 = sunum07.map((item) => {
                    return {
                        cevap07: parseInt(item.cevap),
                    };
                });
                const result07 = Object.values(outputData07).reduce(
                    (r, {
                        cevap07
                    }) => r + cevap07,
                    0
                );
                const longeur07 = sunum07.length;
                let sonuc07 = 100 - (result07 * 100) / longeur07;
                console.log("Soru07 yanlis orani:", sonuc07);
 
  
  
      var loggedIn = localStorage.getItem('auth');
    if (loggedIn) {

    return (
    
    
    
      <div className="row pt-5">
          <div className="col-md-6">
              <div className="list-group">
                  <div className="list-group-item list-group-item-action list-group-item-success">Sunum Sorular Yanlış Oranı</div>
              </div>
              <div className="list-group mb-3">
                  <br />
                  <div className="list-group-item list-group-item-action">
                      Soru 1 : {sonuc01}
                  </div>
                  <div className="list-group-item list-group-item-action">
                      Soru 2 : {sonuc02}
                  </div>
                  <div className="list-group-item list-group-item-action">
                      Soru 3 : {sonuc03}
                  </div>
                  <div className="list-group-item list-group-item-action">
                      Soru 4 : {sonuc04}
                  </div>
                  <div className="list-group-item list-group-item-action">
                      Soru 5 : {sonuc05}
                  </div>
                  <div className="list-group-item list-group-item-action">
                      Soru 6 : {sonuc06}
                  </div>
                  <div className="list-group-item list-group-item-action">
                      Soru 7 : {sonuc07}
                  </div>
              </div>
          </div>
      </div>

    );
    } else {
        return (
          <div className="row top-buffer">
        	<Redirect to="/user/login" />
          </div>
        );
    }



  }
}

export default SunumEligard



// WEBPACK FOOTER //
// src/components/sunum.jsx